import React from "react"
import SvgIcon from "components/SvgIcon/SvgIcon"

/**
 * Category icons of the Black Friday view + the brand slash motif. The five
 * sub-categories use the shop's own category icons (light blue tiles, as in
 * the category filter; PM request of 2026-11-04); only "Toate ofertele",
 * which has no shop icon, keeps a line icon in currentColor.
 */
const SHOP_ICON_NAMES = {
  aer: "ventilatie",
  termice: "termice",
  apa: "apa",
  sanitare: "sanitare",
  energie: "green-energy"
}

const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}

const Toate = () => (
  <g {...base}>
    <rect x="8" y="8" width="20" height="20" rx="3" />
    <rect x="36" y="8" width="20" height="20" rx="3" />
    <rect x="8" y="36" width="20" height="20" rx="3" />
    <rect x="36" y="36" width="20" height="20" rx="3" />
  </g>
)

export const BfCategoryIcon = ({ icon, size = 64, className = "", style }) => {
  const shopIconName = SHOP_ICON_NAMES[icon]
  if (shopIconName)
    return (
      // SvgIcon does not pass a className on: the wrapper carries it
      <span className={`bf-icon bf-icon--shop ${className}`} style={{ width: size, height: size, ...style }} aria-hidden="true">
        <SvgIcon name={shopIconName} style={{ width: "100%", height: "100%", display: "block" }} />
      </span>
    )

  return (
    <svg
      className={`bf-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      style={style}
    >
      <Toate />
    </svg>
  )
}

/** The Uniprest logo's diagonal, used as the campaign's signature mark. */
export const BfSlash = ({ className = "", color = "#ea0029", style }) => (
  <svg
    className={`bf-slash ${className}`}
    viewBox="0 0 1069 1095"
    aria-hidden="true"
    preserveAspectRatio="none"
    style={style}
  >
    <path d="M764.526 1095L0 0H304.474L1069 1095H764.526Z" fill={color} />
  </svg>
)

/** Lockup used in banners, tags and the hero: BLACK (white) / FRIDAY (red). */
export const BfWordmark = ({ className = "", stacked = false }) => (
  <span className={`bf-wordmark ${stacked ? "stacked" : ""} ${className}`}>
    <span className="bf-wordmark__black">Black</span>
    <span className="bf-wordmark__friday">Friday</span>
  </span>
)

export default BfCategoryIcon
